// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AutomationTripsFilters .row {
  --bs-gutter-x: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/features/Automation/pages/AutomationTrips/components/AutomationTripsFilters/styles.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ","sourcesContent":[".AutomationTripsFilters {\n  .row {\n    --bs-gutter-x: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
